import { render, staticRenderFns } from "./closecontrol.vue?vue&type=template&id=4fa5d467&scoped=true&"
import script from "./closecontrol.vue?vue&type=script&lang=js&"
export * from "./closecontrol.vue?vue&type=script&lang=js&"
import style0 from "./closecontrol.vue?vue&type=style&index=0&id=4fa5d467&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5d467",
  null
  
)

export default component.exports